import * as React from "react"

type Props = {
    hoverRow: boolean
    className: string
}
type State = {
    isHovered: boolean
}

class DragDataTableRow extends React.PureComponent<Props, State> {
    state = {
        isHovered: false,
    }
    static defaultProps = {
        className: "",
        hoverRow: false,
    }

    render() {
        const { hoverRow, ...restProps } = this.props
        return (
            <tr
                {...restProps}
                className={
                    (hoverRow || this.state.isHovered ? "row-active " : "") + this.props.className + " draggable-row"
                }
                onMouseEnter={() =>
                    this.setState({
                        isHovered: true,
                    })
                }
                onMouseLeave={() =>
                    this.setState({
                        isHovered: false,
                    })
                }
            />
        )
    }
}

export default DragDataTableRow
